import cx from 'classnames';
import { Image } from 'platform-components';
import React from 'react';

import './content-showcase__illustration.scss';

interface Props {
    imageSrc: string;
    mix?: string;
}

export const ContentShowcaseIllustration = React.memo((props: Props) => {
    const { imageSrc, mix } = props;

    return (
        <div className={cx('content-showcase-widget__illustration', mix)}>
            <Image alt="" src={imageSrc} />
            <svg fill="none" viewBox="0 0 514 302">
                <path
                    d="M101.944 2.5C81.9286 2.5 65.674 3.56921 52.5744 6.48047C39.4465 9.39805 29.3346 14.1988 21.7667 21.7667C14.1988 29.3346 9.39805 39.4465 6.48047 52.5744C3.56921 65.674 2.5 81.9286 2.5 101.944V200.056C2.5 220.071 3.56921 236.326 6.48047 249.426C9.39805 262.553 14.1988 272.665 21.7667 280.233C29.3346 287.801 39.4465 292.602 52.5744 295.52C65.674 298.431 81.9286 299.5 101.944 299.5H412.056C432.071 299.5 448.326 298.431 461.426 295.52C474.553 292.602 484.665 287.801 492.233 280.233C499.801 272.665 504.602 262.553 507.52 249.426C510.431 236.326 511.5 220.071 511.5 200.056V101.944C511.5 81.9286 510.431 65.674 507.52 52.5744C504.602 39.4465 499.801 29.3346 492.233 21.7667C484.665 14.1988 474.553 9.39805 461.426 6.48047C448.326 3.56921 432.071 2.5 412.056 2.5H101.944Z"
                    stroke="white"
                    strokeWidth="5"
                />
            </svg>
        </div>
    );
});
